import { render, staticRenderFns } from "./EnterTextMsg.vue?vue&type=template&id=cf77e63c&scoped=true&"
import script from "./EnterTextMsg.vue?vue&type=script&lang=js&"
export * from "./EnterTextMsg.vue?vue&type=script&lang=js&"
import style0 from "./EnterTextMsg.vue?vue&type=style&index=0&id=cf77e63c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf77e63c",
  null
  
)

export default component.exports